// formate price

export const formatPrice = (price: number) => {
  // Fix for -0.00 bug caused by floating point precision
  const normalizedPrice = Math.abs(price) < 0.001 ? 0 : price;
  const hasDecimals = normalizedPrice % 1 !== 0;

  return new Intl.NumberFormat("pl-PL", {
    style: "currency",
    currency: "PLN",
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: hasDecimals ? 2 : 0,
  }).format(normalizedPrice);
};
